// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"d09a4631","977":"78c2b808"}[chunkId] + ".chunk.js";
};